import { CustomerQueryKeys } from "../Customer/keys";

export const CustomerFeatureQueryKeys = {
  all: (customerId: string) => [
    ...CustomerQueryKeys.single(customerId),
    "features",
  ],
};
